import { Link, createFileRoute, redirect } from '@tanstack/react-router'
import { takePostAuthRedirect } from '@/hooks/use-auth-actions'
import { buttonVariants } from '@/components/ui/button'
import { Logo } from '@/components/logo'

/**
 * Return URL for Google sign-in. The Supabase client exchanges the code while
 * it initialises, before the router runs, so a successful sign-in is already
 * authenticated here.
 */
export const Route = createFileRoute('/auth/callback')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ href: takePostAuthRedirect(), replace: true })
    }
  },
  component: AuthCallbackFailed,
})

function AuthCallbackFailed() {
  return (
    <div className='flex min-h-screen flex-col items-center justify-center px-4'>
      <div className='mx-auto flex w-full max-w-sm flex-col items-center gap-6 text-center'>
        <Logo className='w-12' />
        <div className='flex flex-col gap-1.5'>
          <h1 className='font-heading text-3xl'>Sign-in didn't finish</h1>
          <p className='text-muted-foreground text-sm'>
            It was cancelled or took too long. Try again from the sign-in page.
          </p>
        </div>
        <Link
          to='/sign-in'
          className={buttonVariants({ size: 'md', className: 'w-full' })}
        >
          Back to sign in
        </Link>
      </div>
    </div>
  )
}
